import React from "react";
import Section from "components/common/Section";
import { ButtonLink } from "components/common/Button";
import JuliePhoto from "./assets/julie.jpg";
import JuliePhoto2x from "./assets/2x/julie.jpg";
import "./AboutSection.scss";

const ProfileImageContent = () => (
	<div className="profileImageContent">
		<img alt="Profile of Julie Kuang" className="profileImage" src={JuliePhoto} srcSet={`${JuliePhoto2x} 2x`}/>
	</div>
);

const TextContent = () => (
	<div className="textContent">
		<div className="title font-size-large">
			Hi! I’m Julie, a Senior UX Designer currently working at LinkedIn.
		</div>
		<div className="subText font-size-base font-family-open-sans">
			User experience designer with a love of designing digital experiences. I believe that product designs should be guided by our user needs and be simple yet delightful, beautiful yet functional.
		</div>
		<ButtonLink
			href="mailto:jkuang522@gmail.com"
			className="contactBtn"
			text="Contact me"
			useLink={false}
		/>
	</div>
);

const AboutSection = () => {
	return (
		<Section
			className="aboutSection"
			hasGreyBackground={true}
			includeVerticalPadding={false}
		>
			<div className="sectionContent desktop-max-width-base">
				<ProfileImageContent />
				<TextContent />
			</div>
		</Section>
	);
};

export default AboutSection;



// WEBPACK FOOTER //
// ./src/components/pages/index/AboutSection.js